;
define("product_line_stock_description.tpl", function(){});

